<template>
  <v-container grid-list-xl>
    <h1 class="display-1">Versendungen</h1>
    <v-layout row>
      <v-flex>
        <v-select
          :items="standorte"
          menu-props="auto"
          item-text="Standort"
          v-model="selectedStandort"
          label="Standort"
          return-object
        />
      </v-flex>
      <v-flex>
        <v-select
          :items="verfahren"
          menu-props="auto"
          item-text="Verfahren"
          v-model="selectedVerfahren"
          label="Verfahren"
        />
      </v-flex>
    </v-layout>
    <v-layout column>
      <v-flex v-for="item in visibleItems" :key="item.vId">
        <v-card>
          <v-card-title>
            <div>
              <h3 class="headline mb-0">{{ item.veranstaltung }}</h3>
              <div>{{ item.ort }} - {{ formatDate(item.datum) }}</div>
            </div>
          </v-card-title>
          <v-expansion-panel inset>
            <v-expansion-panel-content>
              <div slot="header">Prüfungsstücke</div>
              <v-data-table :items="item.items" hide-actions hide-headers>
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.Bezeichnung }}</td>
                  <td>{{ props.item.PrfStkNr }}</td>
                  <td>{{ props.item.Standort }}</td>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-card-actions>
            <v-btn color="teal" flat @click="receivedItems(item)"
              >Zurückerhalten</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import orderby from 'lodash.orderby';
import groupby from 'lodash.groupby';

export default {
  name: 'VersendungMainPage',
  data() {
    return {
      isLoading: true,
      loadingProgress: 0,
      allItems: [],
      standorte: [],
      verfahren: [],
      selectedStandort: null,
      selectedVerfahren: null
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.isLoading = true;
        var [resp] = await Promise.all([this.$http.get('versendung')]);

        var tmpStandorte = [{ Standort: 'Alle', SV_ORT: 'Alle' }];
        var sendungsOrte = Object.entries(groupby(resp.body, 'SV_Ort')).map(
          m => {
            return { Standort: m[1][0].ZielOrt, SV_ORT: m[1][0].SV_Ort };
          }
        );

        tmpStandorte.push(...orderby(sendungsOrte, ['Standort']));
        this.standorte = tmpStandorte;
        this.selectedStandort = tmpStandorte[0];

        var sendungsVerfahren = Object.entries(groupby(resp.body, 'Verfahren'))
          .map(m => m[0])
          .sort();

        this.verfahren = ['Alle'].concat(sendungsVerfahren);
        this.selectedVerfahren = this.verfahren[0];

        var grouped = groupby(resp.body, 'PrüfungId');

        this.allItems = orderby(
          Object.entries(grouped).map(m => {
            let name = m[1][0].Veranstaltung;
            let ort = m[1][0].ZielOrt;
            let svOrt = m[1][0].SV_Ort;
            let datum = m[1][0].Prüfungsdatum;
            let verfahren = m[1][0].Verfahren;

            return {
              vId: m[0],
              veranstaltung: name,
              datum: datum,
              ort: ort,
              SV_Ort: svOrt,
              verfahren: verfahren,
              items: m[1]
            };
          }),
          o => o.datum,
          ['asc']
        );
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    receivedItems(versendung) {
      var ids = versendung.items.map(m => m.Id);

      this.$http
        .put('versendung/received', ids)
        .then(resp => this.loadData())
        .catch(err => console.error(err));
    },
    formatDate(date) {
      var options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(date).toLocaleDateString('de-DE', options);
    }
  },
  computed: {
    visibleItems() {
      const ort = (this.selectedStandort || {}).SV_ORT || 'Alle';
      const verfahren = this.selectedVerfahren || 'Alle';
      return this.allItems
        .filter(f => ort === 'Alle' || f.SV_Ort === ort)
        .filter(f => verfahren === 'Alle' || f.verfahren === verfahren);
    }
  }
};
</script>
